import React, { useContext } from "react";
import { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PackageCard from "./PackageCard";
import bronzeImg from "./fresher.png";
import goldImg from "./elite.png";
import silverImg from "./experience.png";
import hireStarLogo from "./hireStarLogo.png";
import { FormContext } from "../../Context/FormContext";
import ModalComponent from "./Modal/ModalComponent";
// import { useFormContext } from "../../Context/FormContext";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/ContactUsPageAssest/header-bg.svg";
// ContactUsPageAssest/header-bg.svg
const packages = [
  {
    name: "Fresher",
    image: bronzeImg,
    price: 999,
    features: [
      "ID Verification",
      "Crime Check",
      "Education Check",
      "Address Verification (Virtual)",
    ],
  },
  {
    name: "Experience",
    image: silverImg,
    price: 1299,
    features: [
      "ID Verification",
      "Crime Check",
      "Education Check",
      "Address Verification (Virtual)",
      "Past Employment Check",
      "UAN Check",
    ],
  },
  {
    name: "Experience Elite",
    image: goldImg,
    price: 1499,
    features: [
      "ID Verification",
      "Crime Check",
      "Education Check",
      "Address Verification (Virtual)",
      "Past Employment Check",
      "UAN Check",
      "Credit History",
    ],
  },
];
const CandidateDetailsForm = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const { companyDetails, signUpDetails } = useContext(FormContext);
  const [getPrice, setPrice] = useState(undefined);
  const [initialOpacity, setInitialOpacity] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [getSelectedServices, setSelectedServices] = useState([]);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  const handleSelect = (name) => {
    // console.log(name);
    // console.log(selectedPackage);
    setInitialOpacity(false);
    const newSelection = name === selectedPackage ? null : name;
    setSelectedPackage(newSelection);
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    navigate("/get-a-quote");
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async (data) => {
    console.log("hey");

    if (selectedPackage === null) {
      toast.error("Please choose a package!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    // Open the modal when the Calculate button is clicked and a package is selected
    setIsModalOpen(true);

    // const requestBody = {
    //   package:
    //     selectedPackage === "Customize Package"
    //       ? "customized"
    //       : selectedPackage,
    //   candidateEmail: data.candidateEmail,
    //   candidateName: data.candidateName,
    //   candidateMobileNumber: data.candidateMobileNumber,
    // };

    // const { first_name, last_name, ...restData } = signUpDetails;
    // const finalRequestBody = {
    //   ...signUpDetails,
    //   ...requestBody,
    // };

    // console.log("finalRequestBody", finalRequestBody);
    // try {
    //   const response = await fetch(
    //     // `${process.env.REACT_APP_OFFERS_URL}/internalServices/packageSelectedMail`,
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(finalRequestBody),
    //     }
    //   );

    //   if (!response.ok) {
    //     throw new Error("Failed to submit candidate details!");
    //   }

    //   const result = await response.json();
    //   if (result?.message === "request successful") {
    //     toast.success("Form submitted successfully!", {
    //       position: "top-center",
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //     setTimeout(() => {
    //       if (selectedPackage === "Customize Package") {
    //         navigate("/submission-success");
    //       } else {
    //         navigate("/");
    //       }
    //     }, 5000);
    //   }
    // } catch (error) {
    //   toast.error("Failed to submit candidate details. Please try again !", {
    //     position: "top-center",
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    // }
  };

  const formRef = useRef(null);
  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
  return (
    <>
      <ToastContainer />
      <div
        className={`relative w-full  bg-cover bg-no-repeat h-[600px] header-container`}
      >
        <div className="header-content m-auto max-w-4xl absolute inset-0 flex flex-col justify-center items-center text-center">
          <h1 className="text-[30px] md:text-[54px] lg:text-[54px] font-medium text-white">
            Choose Package with hirestar.io
          </h1>
        </div>
      </div>
      <div className="relative lg:mx-6 z-10">
        <div className="max-w-6xl relative mx-auto">
          <div
            ref={formRef}
            className="flex flex-col mx-4 lg:mx-0 md:mx-4 items-center justify-center min-h-screen relative -top-20 md:-top-36 lg:-top-36 left-0 right-0"
          >
            <div className="w-full max-w-5xl lg:p-12 md:p-8 p-6 bg-white shadow-lg rounded-[24px]">
              {/* <h2 className="text-5xl text-center text-[#3A3C3D] font-semibold mb-4 mt-8">
                Candidate Details
              </h2>
              <p className="text-center md:w-2/3 lg:w-2/3 mx-auto font-normal text-[#4D4F4F] mb-12">
                Flexible Packages & Pricing. Pick from 200+ checks
              </p> */}
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label
                      htmlFor="full-name"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Full Name
                    </label>
                    <input
                      {...register("candidateName", {
                        required: "First name is required",
                      })}
                      type="text"
                      id="full-name"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.candidateName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.candidateName.message}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <label
                      htmlFor="email"
                      className="text-[#797D82] text-base font-normal mb-1"
                    >
                      Email
                    </label>
                    <input
                      {...register("candidateEmail", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid email address",
                        },
                      })}
                      type="email"
                      id="email"
                      className="w-full p-2 border border-[#C8C9C9] rounded-lg focus:outline-none focus:border-[#1571B7] focus:shadow-sm focus:shadow-[#1571B7]"
                    />
                    {errors.candidateEmail && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.candidateEmail.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col">
                  <label
                    htmlFor="phone-number"
                    className="text-[#797D82] text-base font-normal mb-1"
                  >
                    Mobile No.
                    <p className="text-[#9C9EA2] text-sm my-1 font-normal">
                      include dialing code eg. +91 for India
                    </p>
                  </label>
                  <div className="flex border border-[#C8C9C9] rounded-lg focus-within:border-[#1571B7] focus-within:shadow-sm focus-within:shadow-[#1571B7]">
                    <select
                      id="dialing-code"
                      className="p-2 border-r-0 appearance-none bg-transparent pr-8 focus:outline-none"
                      style={{
                        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23797D82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>')`,
                        backgroundPosition: "right 0.4rem center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "1.5rem",
                        borderRadius: "0.8rem",
                      }}
                    >
                      <option value="+91">+91</option>
                    </select>
                    <span className="w-[1px] my-2 bg-[#797D82]"></span>
                    <input
                      {...register("candidateMobileNumber", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]{9,15}$/,
                          message: "Invalid phone number",
                        },
                      })}
                      type="tel"
                      id="phone-number"
                      className="w-full p-2 border-none rounded-r-lg focus:outline-none focus:ring-0"
                      inputMode="numeric"
                      maxLength={10}
                    />
                  </div>
                  {(errors.candidateMobileNumber ||
                    errors.candidateMobileNumber) && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.dialing_code?.message ||
                        errors.candidateMobileNumber?.message}
                    </p>
                  )}
                </div> */}

                <div className="choose-package-container">
                  <div className="min-h-screen flex flex-col items-center justify-center">
                    <h1 className="text-5xl text-center text-[#3A3C3D] font-semibold mb-6 mt-6">
                      Choose Package
                    </h1>
                    <p className="text-center text-gray-600 mb-6">
                      Start with the Plan That Fits You Best
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                      {packages.map((pkg, index) => (
                        <PackageCard
                          key={index}
                          name={pkg.name}
                          image={pkg.image}
                          features={pkg.features}
                          price={pkg.price}
                          setPrice={setPrice}
                          setSelectedServices={setSelectedServices}
                          selected={selectedPackage === pkg.name}
                          onSelect={handleSelect}
                          initialOpacity={initialOpacity}
                          setInitialOpacity={setInitialOpacity}
                        />
                      ))}
                    </div>
                    <div
                      className={`w-full cursor-pointer max-w-[calc(100%/3*3+2rem)] mx-auto border rounded-[24px] transform transition duration-300 hover:scale-105 hover:shadow-md flex flex-col relative ${
                        selectedPackage === "Customize Package"
                          ? "border-2 border-[#3CB371]"
                          : `hover:shadow-sm ${
                              initialOpacity ? "opacity-100" : "opacity-70"
                            }`
                      }`}
                      onClick={() => handleSelect("Customize Package")}
                    >
                      <div className="bg-[#1988C8] text-white text-center p-3 rounded-t-[22px]">
                        <h2 className="text-xl font-medium">
                          Customize Package
                        </h2>
                      </div>
                      <div className="bg-white lg:p-14 md:p-14 p-8 rounded-b-[30px] text-center relative flex-grow">
                        <p className="lg:mt-2 font-normal text-2xl leading-relaxed tracking-wider">
                          You have the option to select from <br />
                          more than{" "}
                          <span className="text-[#1988C8] font-bold">
                            200+
                          </span>{" "}
                          available checks
                        </p>
                        <img
                          src={hireStarLogo}
                          alt="Left image"
                          className="absolute bottom-0 left-8 w-[100px] z-10"
                        />
                        <img
                          src={hireStarLogo}
                          alt="Right image"
                          className="absolute bottom-0 right-8 w-[100px] z-10"
                        />
                      </div>
                      {selectedPackage === "Customize Package" && (
                        <div className="absolute bottom-0 w-full bg-[#3CB371] text-white text-center py-2 rounded-b-[22px] font-medium text-sm z-20">
                          Selected
                        </div>
                      )}
                    </div>
                  </div>
                  {isModalOpen && (
                    <ModalComponent
                      isOpen={isModalOpen}
                      getSelectedServices={getSelectedServices}
                      packageData={packages}
                      onClose={handleCloseModal}
                      selectedPackage={selectedPackage}
                      onConfirm={handleConfirm}
                      getPrice={getPrice}
                    />
                  )}
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="self-center book_demo_btn home_button mb-14 px-6 py-3.5 mt-4 ml-2.5 max-w-full text-base font-medium text-white shadow-sm rounded-[61px] w-[182px] max-md:px-5 max-md:mt-10"
                  >
                    Calculate
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateDetailsForm;
